import { c as _c } from "react/compiler-runtime";
import { useParams } from "next/navigation";
import { useActionState } from "react";
import { slettUtkastServerAction } from "@/server/actions/slettUtkast";
import type { FetchUpdateResult } from "@/server/tokenXFetch/FetchResult";
type ActionPayload = {
  onSuccess: () => void;
};
export default function useSlettUtkastAction() {
  const $ = _c(5);
  const {
    narmesteLederId
  } = useParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      error: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [t1, slettUtkastAction, isPendingSlettUtkast] = useActionState(innerSlettUtkastAction, t0);
  const {
    error
  } = t1;
  async function innerSlettUtkastAction(_previousState, t2) {
    const {
      onSuccess
    } = t2;
    const actionState = await slettUtkastServerAction(narmesteLederId);
    if (actionState.error === null) {
      onSuccess();
    }
    return actionState;
  }
  let t3;
  if ($[1] !== error || $[2] !== isPendingSlettUtkast || $[3] !== slettUtkastAction) {
    t3 = {
      slettUtkastAction,
      isPendingSlettUtkast,
      error
    };
    $[1] = error;
    $[2] = isPendingSlettUtkast;
    $[3] = slettUtkastAction;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}